import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HpJourneyStepperComponent } from './hp-journey-stepper.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [HpJourneyStepperComponent],
  imports: [
    CommonModule, SharedModule
  ],
  exports: [HpJourneyStepperComponent]
})
export class HpJourneyStepperModule { }
